import * as React from "react";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import FullWidthContainer from "components/FullWidthContainer";
import Illustration from "components/Illustration";

const Blockquote = ({quote, source, illustration, flush, background, backgroundImage, backgroundProps, padding}) => {
	const inlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage})`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	return (
		<FullWidthContainer sx={(Object.keys(inlineStyle).length > 0 ? inlineStyle : null)} className={`SmartTag-root Blockquote-root ${background||''} ${padding ? 'padding-normal' : ''} ${flush ? 'margin-flush' : ''}`}>
			<Container>
				<Grid container>
					{ illustration &&
						<Grid size={{ xs: 12, sm: 4 }}>
							<Illustration className="Blockquote-illustration" illustration={illustration} />
						</Grid>
					}
					<Grid size={{ xs: 12, sm: (illustration ? 8 : 12) }}>
						<Typography component="blockquote" variant="h3" className="Blockquote-quote">{quote}</Typography>
						<Typography component="cite" variant="body1" className="Blockquote-source">{source}</Typography>
					</Grid>
				</Grid>
			</Container>
		</FullWidthContainer>
	)
}

export default Blockquote;